import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const formatPublishedWork = ({
	pw_title: title,
	pw_citation_or_publisher: citationOrPublisher,
	pw_issue: issue,
	pw_year: year,
}) => {
	let publishedWork = title;

	if (citationOrPublisher) {
		publishedWork += `, ${citationOrPublisher}`;
	}
	if (issue) {
		publishedWork += `, ${issue}`;
	}
	if (year) {
		publishedWork += `, ${year}`;
	}

	return publishedWork;
};

const PublishedWorks = (props) => {
	const publishedWorks = props.data.published_works;

	if (!_.isArray(publishedWorks) || _.isEmpty(publishedWorks)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(publishedWorks, publishedWork => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{formatPublishedWork(publishedWork)}
				</li>
			))}
		</ul>
	);
};

PublishedWorks.propTypes = {
	data: PropTypes.object.isRequired,
};

export default PublishedWorks;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/published-works.js